var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.dataLeft && _vm.dataRight)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('ContentFragment',{attrs:{"content":_vm.dataLeft}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('ContentFragment',{attrs:{"content":_vm.dataRight}})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }